import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXlsx = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.04498 15.255H8.27499L7.50499 14.03L6.735 15.255H6L7.08499 13.575L6.07 12H6.83999L7.53999 13.155L8.23999 12H8.97498L7.95999 13.61L9.04498 15.255Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.53418 15.255V12H10.2342V14.695H11.5642V15.255H9.53418Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1195 14.345C14.1195 14.625 14.0145 14.87 13.8045 15.045C13.5945 15.22 13.3145 15.29 12.9295 15.29C12.5795 15.29 12.2645 15.22 12.0195 15.08V14.45C12.2295 14.555 12.4395 14.625 12.5795 14.66C12.7195 14.695 12.8595 14.73 12.9995 14.73C13.1395 14.73 13.2795 14.695 13.3495 14.66C13.4195 14.59 13.4545 14.52 13.4545 14.415C13.4545 14.345 13.4195 14.31 13.3845 14.24C13.3495 14.17 13.2795 14.135 13.2445 14.1C13.1745 14.065 13.0345 13.995 12.8245 13.89C12.6145 13.785 12.4745 13.715 12.3695 13.61C12.2645 13.505 12.1945 13.435 12.1245 13.295C12.0545 13.19 12.0195 13.05 12.0195 12.91C12.0195 12.63 12.1245 12.385 12.2995 12.245C12.5095 12.07 12.7545 12 13.1045 12C13.2795 12 13.4195 12.035 13.5945 12.07C13.7345 12.105 13.9095 12.175 14.0845 12.245L13.8745 12.77C13.6995 12.7 13.5595 12.665 13.4545 12.63C13.3495 12.595 13.2445 12.595 13.1045 12.595C12.9645 12.595 12.8595 12.63 12.7895 12.7C12.7195 12.77 12.6845 12.84 12.6845 12.945C12.6845 13.015 12.6845 13.05 12.7195 13.12C12.7545 13.19 12.7895 13.225 12.8595 13.26C12.9295 13.295 13.0695 13.365 13.2795 13.505C13.5945 13.645 13.8045 13.785 13.9095 13.925C14.0145 14.065 14.1195 14.135 14.1195 14.345Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4102 15.255H16.6402L15.8702 14.03L15.1002 15.255H14.3652L15.4502 13.575L14.4352 12H15.2052L15.9052 13.155L16.6052 12H17.3402L16.3252 13.61L17.4102 15.255Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0996 3V7.8H18.8996",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9 17V8.21421C18.9 7.949 18.7946 7.69464 18.6071 7.50711L14.3929 3.29289C14.2054 3.10536 13.951 3 13.6858 3H5.5C4.94771 3 4.5 3.44772 4.5 4V17",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 18.3V20C4.5 20.5523 4.94772 21 5.5 21H17.9C18.4523 21 18.9 20.5523 18.9 20V18.3",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
export default SvgXlsx;
